import React from "react";
import FullScreenLayout from "../../layout/FullScreenLayout";
import { ModalHeader, ModalHeading } from "./UserSettings.style";
import { useTranslation } from "hhn-commons";
import { Container, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface AddUserModalProps {
  closeModal: () => void;
}

export const AddUserModal: React.FC<AddUserModalProps> = ({ closeModal }) => {
  const { t } = useTranslation();
  return (
    <FullScreenLayout>
      <Container data-testid="add-user">
        <ModalHeader>
          <ModalHeading>{t("notImplemented")}</ModalHeading>
          <IconButton
            size="large"
            color="inherit"
            data-testid="close-add-user"
            onClick={closeModal}
          >
            <CloseIcon />
          </IconButton>
        </ModalHeader>
      </Container>
    </FullScreenLayout>
  );
};
